import BaseConverter from './BaseConverter'
import { ToHTMLConverter, middlewares } from '../util/toHTML'
import { sanitizeText, createEmptyBlock } from '../util/draftUtils'

export default class TextConverter extends BaseConverter {
  constructor(ansType = 'text', draftTypes = ['unstyled', 'paragraph']) {
    super(ansType, draftTypes)
    this._htmlConverter = new ToHTMLConverter()
    this._htmlConverter.addMiddleware(
      new middlewares.HighlightToHTMLConverterMiddleware()
    )
    this._htmlConverter.addDefaultMiddleware()
  }

  appendAndGetBlocks(element = {}, context) {
    if (element.content) {
      const content = sanitizeText(element.content)
      const blocksFromHTML = context.toDraftBlock(content, element, [
        createEmptyBlock(),
      ])
      return context.appendBlock(blocksFromHTML.contentBlocks)
    }
    return null
  }

  toAnsDataFromBlocks(contentState, [block]) {
    // Do not export automatically created empty blocks
    if (block.getData().get('isEmpty')) {
      return null
    }

    const content = this._htmlConverter.convert(block, true)

    return {
      type: this.getAnsType(),
      content: content,
    }
  }
}
